import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import ProjectCard from '../components/ProjectCard';
import Footer from '../components/Footer';
import './Portfolio.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/projects`);
        const reverseChronological = [...response.data].reverse();
        setProjects(reverseChronological);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <div className="portfolio-page-wrapper">
      <div className="portfolio-page">
        {/* Header Section */}
        <header className="portfolio-header">
          <p>
            Explore our curated gallery of production architectures, mission-critical web platforms, 
            and scalable digital solutions built for modern business performance.
          </p>
        </header>

        {loading ? (
          <div className="portfolio-loading-state">
            <FontAwesomeIcon icon={faSpinner} spin className="spinner-icon" />
            <p>Curating our engineering showcase...</p>
          </div>
        ) : projects.length === 0 ? (
          <div className="portfolio-empty-state">
            <FontAwesomeIcon icon={faFolderOpen} className="empty-icon" />
            <h3>No Deployments Found</h3>
            <p>Our upcoming client projects and architectures are currently undergoing deployment.</p>
          </div>
        ) : (
          <div className="portfolio-grid">
            {projects.map((proj, index) => (
              <ProjectCard
                key={proj._id || index}
                image={proj.image}
                name={proj.name}
                description={proj.description}
                link={proj.link}
                tags={proj.tags || proj.techStack || []}
                index={index}
              />
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Portfolio;